import { render, staticRenderFns } from "./BookTotalRuleConfig.vue?vue&type=template&id=135ea348&scoped=true"
import script from "./BookTotalRuleConfig.vue?vue&type=script&lang=js"
export * from "./BookTotalRuleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ea348",
  null
  
)

export default component.exports